<template>
  <div>
    <window
      ref="openWindowA"
      v-if="isVisibleEdit"
      :title="Title"
      :stage="'FULLSCREEN'"
      :maximize-button="() => null"
      :restore-button="() => null"
      @close="isFieldsChanged"
      class="styleWindow"
      :style="{
        '--status-color': operationStatus ? '#08c75e' : operationStatus === false ? 'red' : 'transparent'
      }"
    >
      <div class="col-12">
        <div class="card bg-white mb-3" style="border-radius: 10px">
          <div class="card-body">
            <AlertComponent
              v-if="isCancelButtonClicked && isSaveEnabled"
              @setWindow="setWindow"
              :isCancelButtonClicked="isCancelButtonClicked"
              @hidePopup="isCancelButtonClicked = false"
            ></AlertComponent>
            <DuplicateStyle
              :showPopup="showPopup"
              @visibleDialog="showPopup = $event"
              :duplicateStyleId="styleId"
              @duplicateId="editStyle($event)"
            ></DuplicateStyle>
            <table style="width: 100%" aria-hidden="true">
              <tbody>
                <tr>
                  <td>
                    <StyleComp
                      class="col-5"
                      :errorMsgStyle="errorMsgStyle"
                      :remaningLengthStyle="styleNameVal.length"
                      :maxStyle="maxStyle"
                      :disableStyle="disableStyle"
                      :inputStyleName="styleNameVal"
                      :Title="styleName"
                    ></StyleComp>
                  </td>
                  <td>
                    <ListComponent
                      class="col"
                      @onChange="validateCustomer"
                      :error="errorMsgCustomer"
                      :Data="customers"
                      :Value="customerVal"
                      :Title="customer"
                    ></ListComponent>
                  </td>
                  <td>
                    <NumberOfInput
                      :Title="noOfGarments"
                      class="col-6"
                      @onChangeVal="validateGarmentValue"
                      :error="errorMsgGarment"
                      :Value="noOfGarmentsVal"
                    ></NumberOfInput>
                  </td>
                  <td>
                    <NumberOfInput
                      :Title="noOfProductLine"
                      class="col-6"
                      @onChangeVal="validateProductionLineValue"
                      :error="errorMsgProductLine"
                      :Value="noOfProductLineVal"
                    ></NumberOfInput>
                  </td>
                </tr>
                <tr>
                  <td>
                    <ListComponent
                      :Title="productCategory"
                      class="col"
                      @onChange="validateProductCategory"
                      :error="errorMsgProductCategory"
                      :Data="productCategoryData"
                      :Value="productCategoryVal"
                    ></ListComponent>
                  </td>
                  <td>
                    <ListComponent
                      :Title="productType"
                      class="col"
                      @onChange="validateProductType"
                      :error="errorMsgProductType"
                      :Data="productTypeData"
                      :Value="productTypeVal"
                    ></ListComponent>
                  </td>
                  <td>
                    <ListComponent
                      v-if="isCalculationEngineLoaded && !isV4CalculationEngine"
                      class="col"
                      @onChange="setCustomSetting"
                      :error="errorMsgCustomSetting"
                      :Data="customSettings"
                      :Value="settingVal"
                      :Title="customSetting"
                    ></ListComponent>
                  </td>
                  <td rowspan="2" style="vertical-align: top">
                    <Description
                      :Title="description"
                      class="col-4"
                      style="height: 135px"
                      :showFields="showFields"
                      :remaningLengthDescription="remaningLengthDescription"
                      :maxDescription="maxDescription"
                      @onChange="setDescriptionValue"
                      :description="descriptionVal"
                    ></Description>
                  </td>
                </tr>
                <tr>
                  <td>
                    <FabricWeight
                      class="col"
                      :Title="fabricWeight"
                      :showFields="showFields"
                      @onChange="setFabricWeight"
                      :weightType="fabricWeightVal"
                    ></FabricWeight>
                  </td>
                  <td>
                    <TextInputComp
                      :Title="color"
                      class="col-4"
                      :showFields="showFields"
                      @onChange="setColorValue"
                      :Value="colorVal"
                    ></TextInputComp>
                  </td>
                  <td>
                    <TextInputComp
                      :Title="size"
                      class="col-4"
                      :showFields="showFields"
                      @onChange="setSizeValue"
                      :Value="sizeVal"
                    ></TextInputComp>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="footer">
            <div class="left-footer-buttons">
              <button
                :disabled="!isSaveEnabled"
                type="button"
                class="btn btn-sm btn-primary"
                @click.prevent="onSubmitSave"
                style="width: 92px; border-radius: 5px; background-color: #0054a6; color: white"
              >
                {{ $t("editStyle.save") }}
              </button>
              <button
                :disabled="isSaveEnabled"
                type="button"
                class="btn btn-sm btn-primary cloneButton"
                @click.prevent="showPopup = true"
              >
                {{ $t("styleGrid.colne") }}
              </button>
              <button
                type="button"
                class="btn btn-sm btn-primary"
                @click.prevent="showReportsPopup = true"
                style="width: auto; border-radius: 5px"
                :disabled="disableReportValue"
              >
                <span class="fas fa-file-lines" style="padding-right: 5px"></span>
                {{ $t("styleGrid.reports") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ReportsPopup
        v-if="showReportsPopup"
        @close="showReportsPopup = false"
        :noOfGarments="noOfGarmentsVal"
        :noOfProductLine="noOfProductLineVal"
        :selectedReportPrintingOption="selectedReportPrintingOption"
        @reportFormatChanged="selectedReportPrintingOption = $event"
        @downloadSingleGarmentReport="handleDownloadSingleGarmentReport"
        @downloadSingleGarmentReportWithQuantity="handleDownloadSingleGarmentReportWithQuantity"
        @isChecked="handleIncludeCostElement"
        @downloadThreadUsageReport="handleDownloadThreadGarmentReport"
        @noOfGarments="handleNoOfGarmentsForSGC"
        @noOfProductionLines="handleNoOfProductionLineForTU"
        :loadingGrid="loadingGridVal"
      ></ReportsPopup>
      <OperationListComp
        ref="operationListComp"
        :isAddButtonDisabled="isAddButtonDisabled"
        :ticketTex="ticketTex"
        @overallStatus="handleOperationStatus"
        @disableReport="disableReportValue = $event"
        @allOperationStatusLength="allOperationStatusLength = $event"
        @loadingGridChanged="loadingGridVal = $event"
      ></OperationListComp>
    </window>
  </div>
</template>

<script lang="ts">
import { Window } from "@progress/kendo-vue-dialogs";
import StyleComp from "./StyleComp.vue";
import NumberOfInput from "./NumberOfInput.vue";
import TextInputComp from "./TextInputComp.vue";
import Description from "./Description.vue";
import FabricWeight from "./FabricWeightComp.vue";
import ListComponent from "./ListComponent.vue";
import ImageComp from "./ImageInputComp.vue";
import SeeMore from "./SeeMoreLinkComp.vue";
import OperationListComp from "./OperationListComp.vue";
import {
  StyleApi,
  CustomerApi,
  ProductCategoryApi,
  ProductTypeApi,
  CustomSettingsApi,
  UserAdminSettingApi
} from "@/api";
import {
  CustomerCreateDto,
  ProductCategoryCreateDto,
  ProductTypeCreateDto,
  StyleCreateDto,
  StyleUpdateDto
} from "@/api/model";
import AlertComponent from "./AlertComponent.vue";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import DuplicateStyle from "./DuplicateStylePopup.vue";
import { isStyleDirtyForSave, resetField } from "@/core/utils/CheckUnsavedChanges";
import ReportsPopup from "./ReportsPopup.vue";

export default defineComponent({
  name: "EditStyle",
  components: {
    ReportsPopup,
    Window,
    StyleComp,
    NumberOfInput,
    TextInputComp,
    Description,
    FabricWeight,
    ImageComp,
    SeeMore,
    ListComponent,
    OperationListComp,
    AlertComponent,
    DuplicateStyle
  },
  setup() {
    const styleApi = new StyleApi()!;
    const customerApi = new CustomerApi()!;
    const productCategoryApi = new ProductCategoryApi()!;
    const productTypeApi = new ProductTypeApi()!;
    const customSettingsApi = new CustomSettingsApi()!;
    const userAdminSettingApi = new UserAdminSettingApi()!;
    return {
      styleApi,
      customerApi,
      productCategoryApi,
      productTypeApi,
      customSettingsApi,
      userAdminSettingApi
    };
  },
  data() {
    return {
      showReportsPopup: false,
      toast: useToast(),
      header: this.$t("editStyle.header"),
      styleName: this.$t("editStyle.styleName"),
      customer: this.$t("editStyle.customer"),
      fabricWeight: this.$t("editStyle.fabricWeight"),
      productCategory: this.$t("editStyle.productCategory"),
      productType: this.$t("editStyle.productType"),
      noOfGarments: this.$t("editStyle.noOfGarments"),
      description: this.$t("editStyle.description"),
      noOfProductLine: this.$t("editStyle.noOfProductLine"),
      color: this.$t("editStyle.color"),
      size: this.$t("editStyle.size"),
      quantity: this.$t("editStyle.quantity"),
      allowanceVal: this.$t("editStyle.allowanceVal"),
      customSetting: this.$t("editStyle.chooseSettingTemplate"),
      errorMsgStyle: "",
      errorMsgCustomer: "",
      errorMsgProductCategory: "",
      errorMsgProductType: "",
      errorMsgGarment: "",
      errorMsgProductLine: "",
      errorMsgCustomSetting: "",
      showFields: true,
      isAddButtonDisabled: false,
      Title: "",
      error: "",
      maxStyle: 30,
      maxDescription: 200,
      remaningLengthDescription: 0,
      styleNameVal: "" as any,
      customerVal: "" as any,
      fabricWeightVal: "standard" as any,
      productCategoryVal: "" as any,
      productTypeVal: "" as any,
      noOfGarmentsVal: 1 as any,
      descriptionVal: "" as any,
      noOfProductLineVal: 1 as any,
      colorVal: "" as any,
      sizeVal: "" as any,
      customers: [] as any,
      productCategoryData: [] as any,
      productTypeData: [] as any,
      inputData: {} as any,
      customerData: {} as any,
      productCategoryDataVal: {} as any,
      productTypeDataVal: {} as any,
      styleId: null as any,
      disableStyle: false,
      configuration: "",
      isCancelButtonClicked: false,
      settingVal: "",
      customSettings: [] as any,
      customSettingData: [] as any,
      style: this.$t("editStyle.style"),
      defaultAllowance: "",
      ticketTex: "",
      customId: null as any,
      isVisibleEdit: this.visibleEdit,
      showPopup: false,
      duplicateStyleId: 0,
      initialStyleData: null as any,
      isSaveEnabled: false,
      isFieldDirty: {
        customer: false,
        productCategory: false,
        productType: false,
        numberOfProductionLines: false,
        customSettingId: false,
        description: false,
        weightType: false,
        size: false,
        color: false,
        noOfGarments: false
      },
      operationStatus: null as any,
      disableReportValue: null as any,
      allOperationStatusLength: null as any,
      selectedReportPrintingOption: "pdf" as any,
      includeCostElement: false,
      noOfGarmentsForSGC: 0,
      noOfProductionLineForTU: 0,
      loadingGridVal: false,
      calculationEngineType: "" as any,
      isCalculationEngineLoaded: false as boolean,
      calculationEngineReady: null as any
    };
  },
  props: {
    visibleEdit: null as any,
    editStyleId: null as any,
    duplicateEditId: null as any
  },
  emits: ["update"],
  computed: {
    // GSD V4 has no per-style custom setting; the selection is hidden. Existing styles keep their saved setting.
    isV4CalculationEngine(): boolean {
      const engineType = String(this.calculationEngineType ?? "")
        .trim()
        .toLowerCase();
      return engineType === "gsdv4";
    }
  },
  async created(): Promise<void> {
    await this.getCustomSetting();
    // Keep the promise so submit can await engine resolution and stay deterministic for V4.
    this.calculationEngineReady = this.getCalculationEngineType();
    await this.calculationEngineReady;
    this.getCustomerData();
    this.getProductCategoryData();
    this.getProductTypeData();
    if (this.editStyleId > 0) {
      this.editStyle(this.editStyleId);
    }
    if (this.duplicateEditId > 0) {
      this.editStyle(this.duplicateEditId);
    }
    this.selectedReportPrintingOption = localStorage.getItem("selectedReportPrintingOption");
  },
  methods: {
    handleIncludeCostElement(val: any) {
      this.includeCostElement = val;
    },
    handleNoOfGarmentsForSGC(val: any) {
      this.noOfGarmentsForSGC = val;
    },
    handleNoOfProductionLineForTU(val: any) {
      this.noOfProductionLineForTU = val;
    },
    handleDownloadSingleGarmentReportWithQuantity() {
      (this.$refs.operationListComp as any).downloadSingleGarmentReport(
        this.includeCostElement,
        this.noOfGarmentsForSGC
      );
    },
    handleDownloadSingleGarmentReport() {
      (this.$refs.operationListComp as any).downloadSingleGarmentReport(this.includeCostElement);
    },
    handleDownloadThreadGarmentReport() {
      (this.$refs.operationListComp as any).downloadThreadGarmentReport(
        this.noOfGarmentsForSGC,
        this.noOfProductionLineForTU
      );
    },
    handleDropdownChange(): void {
      localStorage.setItem("selectedReportPrintingOption", this.selectedReportPrintingOption);
    },
    handleOperationStatus(value: any) {
      this.operationStatus = value;
    },
    isFieldsChanged() {
      this.isCancelButtonClicked = true;
      if (!this.isSaveEnabled) {
        globalThis.location.reload();
      }
    },
    setWindow(): void {
      this.$emit("update");
      globalThis.location.reload();
    },
    async setHeader(): Promise<void> {
      await this.getTktTeAndAllowanceByCustomSetting(this.customId);
      this.configuration =
        "(" +
        this.fabricWeight +
        ": " +
        this.fabricWeightVal +
        ")" +
        " " +
        "(" +
        this.quantity +
        ": " +
        this.noOfGarmentsVal +
        ")" +
        " " +
        "(" +
        this.noOfProductLine +
        ": " +
        this.noOfProductLineVal +
        ")" +
        " " +
        "(" +
        this.allowanceVal +
        ": " +
        this.defaultAllowance +
        ")";
      this.Title = this.styleNameVal + ": " + " - " + this.descriptionVal.substring(0, 15) + this.configuration;
    },
    setCustomSetting(value: string): void {
      this.settingVal = value;
      this.validateCustomSetting(this.settingVal);
      this.customId = this.customSettingData.find((a: { name: string }) => a.name == value)?.id;
      this.isSaveEnabled = isStyleDirtyForSave(
        "customSettingId",
        this.initialStyleData,
        this.customId,
        this.isFieldDirty
      );
    },
    async getCustomerData(): Promise<void> {
      await this.customerApi.apiGetCustomersOrderByMostFrequentlyUsedGet().then(async res => {
        for (let customer of res.data) {
          this.customers.push(customer.name);
        }
        this.customerData = res.data;
      });
    },
    async getCustomSetting(): Promise<void> {
      await this.customSettingsApi.apiGetCustomSettingsGet().then(async res => {
        for (let setting of res.data) {
          this.customSettings.push(setting.name);
        }
        this.customSettingData = res.data;
      });
    },
    async getCalculationEngineType(): Promise<void> {
      await this.userAdminSettingApi
        .apiSystemConfigurationGet()
        .then(res => {
          this.calculationEngineType = res.data.calculationEngineType?.defaultItem ?? "";
        })
        .catch(() => {
          return;
        })
        .finally(() => {
          // Only decide the custom-setting visibility once the engine is known, so it never flashes
          // for a GSD V4 tenant before the async config resolves.
          this.isCalculationEngineLoaded = true;
        });
    },
    async getTktTeAndAllowanceByCustomSetting(id: number): Promise<void> {
      await this.customSettingsApi.apiGetCustomSettingByIdGet(id).then(res => {
        this.defaultAllowance = res.data.defaultAllowance as unknown as string;
        this.ticketTex = res.data.tktTex as string;
      });
    },
    async getProductCategoryData(): Promise<void> {
      await this.productCategoryApi.apiGetProductCategoriesOrderByMostFrequentlyUsedGet().then(async res => {
        for (let product of res.data) {
          this.productCategoryData.push(product.name);
        }
        this.productCategoryDataVal = res.data;
      });
    },
    async getProductTypeData(): Promise<void> {
      await this.productTypeApi.apiGetProductTypesOrderByMostFrequentlyUsedGet().then(async res => {
        for (let product of res.data) {
          this.productTypeData.push(product.name);
        }
        this.productTypeDataVal = res.data;
      });
    },
    validateCustomer(value: string): void {
      this.customerVal = value;
      if (value == "" || value == undefined || value == null)
        this.errorMsgCustomer = this.$t("editStyle.pleaseSelectTheCustomer") as string;
      else if (value.length > 30) this.errorMsgCustomer = this.$t("editStyle.maximum30CharacterAreAllowed") as string;
      else this.errorMsgCustomer = "";
      if (this.errorMsgCustomer) {
        this.toast.error(this.errorMsgCustomer, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.customerVal = value.trim();
      }
      this.isSaveEnabled = isStyleDirtyForSave("customer", this.initialStyleData, this.customerVal, this.isFieldDirty);
    },
    validateProductCategory(value: string): void {
      this.productCategoryVal = value;
      if (value == "" || value == undefined || value == null)
        this.errorMsgProductCategory = this.$t("editStyle.pleaseSelectTheProductCategory") as string;
      else this.errorMsgProductCategory = "";
      if (this.errorMsgProductCategory) {
        this.toast.error(this.errorMsgProductCategory, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.productCategoryVal = value.trim();
      }
      this.isSaveEnabled = isStyleDirtyForSave(
        "productCategory",
        this.initialStyleData,
        this.productCategoryVal,
        this.isFieldDirty
      );
    },
    validateProductType(value: string): void {
      this.productTypeVal = value;
      if (value == "" || value == undefined || value == null)
        this.errorMsgProductType = this.$t("editStyle.pleaseSelectTheProductType") as string;
      else this.errorMsgProductType = "";
      if (this.errorMsgProductType) {
        this.toast.error(this.errorMsgProductType, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      } else {
        this.productTypeVal = value.trim();
      }
      this.isSaveEnabled = isStyleDirtyForSave(
        "productType",
        this.initialStyleData,
        this.productTypeVal,
        this.isFieldDirty
      );
    },
    validateCustomSetting(value: string): void {
      if (value == "" || value == undefined || value == null) {
        this.errorMsgCustomSetting = this.$t("editStyle.pleaseSelectCustomSetting") as string;
      } else this.errorMsgCustomSetting = "";
      if (this.errorMsgCustomSetting != "") {
        this.toast.error(this.errorMsgCustomSetting, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    },
    validateGarmentValue(value: string): void {
      this.noOfGarmentsVal = value;
      if (value == "" || value == undefined || value == null)
        this.errorMsgGarment = this.$t("editStyle.pleaseEnterNoOfGarment") as string;
      else if (+value < 1) this.errorMsgGarment = this.$t("editStyle.valueShouldBeAtleast1") as string;
      else if (value.length > 7) {
        this.errorMsgGarment = this.$t("editStyle.maximum7CharactersAreAllowed") as string;
      } else this.errorMsgGarment = "";
      if (this.errorMsgGarment != "") {
        this.toast.error(this.errorMsgGarment, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      this.isSaveEnabled = isStyleDirtyForSave(
        "noOfGarments",
        this.initialStyleData,
        this.noOfGarmentsVal,
        this.isFieldDirty
      );
    },
    validateProductionLineValue(value: string): void {
      this.noOfProductLineVal = value;
      if (value == "" || value == undefined || value == null)
        this.errorMsgProductLine = this.$t("editStyle.pleaseEnterProductionLine") as string;
      else if (+value < 1) this.errorMsgProductLine = this.$t("editStyle.valueShouldBeAtleast1") as string;
      else if (value.length > 2) {
        this.errorMsgProductLine = this.$t("editStyle.maximum2CharactersAreAllowed") as string;
      } else this.errorMsgProductLine = "";
      if (this.errorMsgProductLine != "") {
        this.toast.error(this.errorMsgProductLine, {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
      this.isSaveEnabled = isStyleDirtyForSave(
        "numberOfProductionLines",
        this.initialStyleData,
        this.noOfProductLineVal,
        this.isFieldDirty
      );
    },
    setFabricWeight(value: string): void {
      if (value == "" || value == null || value == undefined) this.fabricWeightVal = "stanadard";
      else this.fabricWeightVal = value;
      this.isSaveEnabled = isStyleDirtyForSave(
        "weightType",
        this.initialStyleData,
        this.fabricWeightVal,
        this.isFieldDirty
      );
    },
    setDescriptionValue(value: string): void {
      this.descriptionVal = value.replace(",", " ");
      this.remaningLengthDescription = value.length;
      this.isSaveEnabled = isStyleDirtyForSave(
        "description",
        this.initialStyleData,
        this.descriptionVal,
        this.isFieldDirty
      );
    },
    setColorValue(value: string): void {
      this.colorVal = value;
      this.isSaveEnabled = isStyleDirtyForSave("color", this.initialStyleData, this.colorVal, this.isFieldDirty);
    },
    setSizeValue(value: string): void {
      this.sizeVal = value;
      this.isSaveEnabled = isStyleDirtyForSave("size", this.initialStyleData, this.sizeVal, this.isFieldDirty);
    },
    async onSubmitSave(): Promise<void> {
      // Ensure the engine type is resolved before submit so V4 enforcement is deterministic
      // even if the user submits before getCalculationEngineType() completes.
      await this.calculationEngineReady;
      if (this.styleId > 0) {
        this.updateStyle();
      } else {
        this.onSubmit();
      }
    },
    onSubmit(): void {
      let checkValidation = this.validateAllFields();
      if (checkValidation) {
        this.setHeader();
        this.disableStyle = true;
        const styleHeaderData = this.getStyleHeaderData();
        this.styleApi
          .apiStylePost(styleHeaderData)
          .then(async res => {
            this.styleId = res.data.id;
            this.isAddButtonDisabled = true;
            sessionStorage.setItem("customSettingId", res.data.customSettingId as unknown as string);
            sessionStorage.setItem("styleId", this.styleId);
            this.toast.success(this.$t("editStyle.dataSavedSuccesfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
          })
          .catch(() => {
            this.toast.error("Error", {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      }
    },
    async updateStyle(): Promise<void> {
      let checkValidation = this.validateAllFields();
      if (checkValidation) {
        this.setHeader();
        this.disableStyle = true;
        const styleHeaderData: StyleUpdateDto = this.getStyleHeaderUpdateData();
        if (styleHeaderData.customerId == 0) {
          const newCustomerVal = { name: this.customerVal } as CustomerCreateDto;
          await this.customerApi.apiCustomerPost(newCustomerVal).then(res => {
            styleHeaderData.customerId = res.data.id as number;
          });
          await this.getCustomerData();
        }
        if (styleHeaderData.productCategoryId == 0) {
          const newProductCategory = { name: this.productCategoryVal } as ProductCategoryCreateDto;
          await this.productCategoryApi.apiProductCategoryPost(newProductCategory).then(res => {
            styleHeaderData.productCategoryId = res.data.id as number;
          });
          await this.getProductCategoryData();
        }
        if (styleHeaderData.productTypeId == 0) {
          const newProductType = { name: this.productTypeVal } as ProductTypeCreateDto;
          await this.productTypeApi.apiProductTypePost(newProductType).then(res => {
            styleHeaderData.productTypeId = res.data.id as number;
          });
          await this.getProductTypeData();
        }
        this.styleApi
          .apiStyleIdPut(this.styleId, styleHeaderData)
          .then(async res => {
            this.styleId = res.data.id;
            sessionStorage.setItem("customSettingId", res.data.customSettingId as unknown as string);
            this.toast.success(this.$t("editStyle.dataSavedSuccesfully") as string, {
              toastClassName: "custom-success-toast",
              timeout: 5000
            });
            this.editStyle(this.styleId);
            resetField(this.isFieldDirty);
            this.isSaveEnabled = false;
          })
          .catch(() => {
            this.toast.error("Error", {
              toastClassName: "custom-error-toast",
              timeout: 5000
            });
          });
      }
    },
    getStyleHeaderUpdateData(): StyleUpdateDto {
      let customer = this.customerData.find(
        (a: { name: string }) => a.name.trim().toLowerCase() == (this.customerVal as string).trim().toLowerCase()
      );
      let customerId = customer == undefined ? 0 : customer.id;
      let productCategoryFound = this.productCategoryDataVal.find(
        (a: { name: string }) => a.name.toLowerCase() == this.productCategoryVal.toLowerCase()
      );
      let productCategoryId: number = productCategoryFound == undefined ? 0 : productCategoryFound.id;
      let productTypeFound = this.productTypeDataVal.find((a: { name: string }) => a.name == this.productTypeVal);
      let productTypeId: number = productTypeFound == undefined ? 0 : productTypeFound.id;
      let fabricWeightId = this.getFabricWeightID(this.fabricWeightVal);
      let seamLengthUnit: boolean = sessionStorage.getItem("saemLengthUnit") == "Imperial";
      let customSetting = this.customSettingData.find((a: { name: string }) => a.name == (this.settingVal as string));
      let customSettingId = customSetting == "Default" || customSetting == undefined ? 0 : customSetting.id;
      const styleHeaderData: StyleUpdateDto = {
        name: this.styleNameVal,
        color: this.colorVal,
        description: this.descriptionVal,
        size: this.sizeVal,
        weightType: fabricWeightId,
        quantity: this.noOfGarmentsVal,
        numberOfProductionLines: this.noOfProductLineVal,
        productCategoryId: productCategoryId,
        customerId: customerId,
        isImperial: seamLengthUnit,
        productTypeId: productTypeId,
        contentJson: 0,
        customSettingId: customSettingId
      } as StyleUpdateDto;
      return styleHeaderData;
    },
    getStyleHeaderData(): StyleCreateDto {
      let customerId: number = this.customerData.find(
        (a: { name: string }) => a.name.trim().toLowerCase() == (this.customerVal as string).trim().toLowerCase()
      ).id;
      let productCategoryData = this.productCategoryDataVal.find(
        (a: { name: string }) => a.name == this.productCategoryVal
      );
      let productCategoryId: number = productCategoryData == undefined ? 0 : productCategoryData.id;
      let productTypeId: number = this.productTypeDataVal.find(
        (a: { name: string }) => a.name == this.productTypeVal
      ).id;
      let fabricWeightId = this.getFabricWeightID(this.fabricWeightVal);
      let seamLengthUnit: boolean = sessionStorage.getItem("saemLengthUnit") == "Imperial";
      let customSetting = this.customSettingData.find((a: { name: string }) => a.name == (this.settingVal as string));
      let customSettingId = customSetting == "Default" || customSetting == undefined ? 0 : customSetting.id;
      const styleHeaderData: StyleCreateDto = {
        name: this.styleNameVal,
        color: this.colorVal,
        description: this.descriptionVal,
        size: this.sizeVal,
        weightType: fabricWeightId,
        quantity: this.noOfGarmentsVal,
        numberOfProductionLines: this.noOfProductLineVal,
        productCategoryId: productCategoryId,
        customerId: customerId,
        isImperial: seamLengthUnit,
        productTypeId: productTypeId,
        contentJson: 0,
        customSettingId: customSettingId
      } as StyleCreateDto;
      return styleHeaderData;
    },
    getFabricWeightID(value: string): number {
      if (value == "light") {
        return 1;
      } else if (value == "heavy") {
        return 3;
      }
      return 2;
    },
    validateAllFields(): boolean {
      if (this.disableStyle) {
        this.validateCustomer(this.customerVal as string);
        this.setFabricWeight(this.fabricWeightVal);
        this.validateProductCategory(this.productCategoryVal);
        this.validateProductType(this.productTypeVal);
        if (!this.isV4CalculationEngine) this.validateCustomSetting(this.settingVal);
        this.validateGarmentValue(this.noOfGarmentsVal);
        this.validateProductionLineValue(this.noOfProductLineVal);
      } else {
        this.validateCustomer(this.customerVal as string);
        this.setFabricWeight(this.fabricWeightVal);
        this.validateProductCategory(this.productCategoryVal);
        if (!this.isV4CalculationEngine) this.validateCustomSetting(this.settingVal);
        this.validateProductType(this.productTypeVal);
        this.validateGarmentValue(this.noOfGarmentsVal);
        this.validateProductionLineValue(this.noOfProductLineVal);
      }
      if (
        this.errorMsgCustomer != "" ||
        this.errorMsgGarment != "" ||
        this.errorMsgProductCategory != "" ||
        this.errorMsgProductType != "" ||
        this.errorMsgStyle != "" ||
        this.errorMsgProductLine != "" ||
        this.errorMsgCustomSetting != ""
      ) {
        return false;
      }
      return true;
    },
    async editStyle(Id: number): Promise<void> {
      this.disableStyle = true;
      this.isAddButtonDisabled = true;
      this.styleId = Id;
      sessionStorage.setItem("styleId", this.styleId);
      await this.styleApi
        .apiStyleIdGet(Id)
        .then(async res => {
          this.initialStyleData = res.data;
          this.styleNameVal = res.data.name;
          this.customerVal = res.data.customer as string;
          this.productCategoryVal = res.data.productCategory;
          this.productTypeVal = res.data.productType;
          this.noOfGarmentsVal = res.data.quantity;
          this.noOfProductLineVal = res.data.numberOfProductionLines;
          this.fabricWeightVal = res.data.weightType?.toLowerCase();
          this.descriptionVal = res.data.description;
          this.colorVal = res.data.color;
          this.sizeVal = res.data.size;
          this.settingVal = this.customSettingData.find(
            (a: { id: number | undefined }) => a.id == res.data.customSettingId
          ).name;
          this.customId = res.data.customSettingId as number;
          sessionStorage.setItem("customSettingId", res.data.customSettingId as unknown as string);
        })
        .catch(ex => {
          throw ex;
        })
        .finally(() => {
          this.setHeader();
          this.isVisibleEdit = true;
          (this.$refs.operationListComp as any).getOperationList(this.styleId);
        });
    }
  }
});
</script>

<style scoped>
.inputDiv1 {
  display: flex;
  width: 70%;
  justify-content: left;
  align-items: center;
  margin: 21px;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 38px;
}
.left-footer-buttons,
.right-footer-buttons {
  display: flex;
  gap: 10px;
}
td {
  padding: 6px;
}
</style>
